import { dmpParams } from './../store/dmp'
import { publicParams } from './../store/index'
import { parseQuery } from './../utils/index'

/**
 * dmp构造函数
 * @param {Object} args 实例化参数
 */
export default function Constructor(args) {
    let params = args;
    if (!params) params = {};

    // 合并params.dmp
    if (params.dmp) {
        params = Object.assign(params, params.dmp)
    }

    // 存起参数
    for (let attr in params) {
        if (publicParams[attr] !== undefined) {
            publicParams[attr] = params[attr]
        } else if (dmpParams.hasOwnProperty(attr)) {
            dmpParams[attr] = params[attr]
        }
    }

    // 参数转对象
    publicParams.searchObj = parseQuery(publicParams.searchUrl)
}